export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-14-aab8cb630e2c77119c44304e487b717f.jpg";